module.exports = __webpack_public_path__ + "img/Tutilabs-logo.1c23ebe6.svg";